import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      !_vm.isModal
        ? [
            _c("div", { staticClass: "display-1" }, [_vm._v("Sugerencias")]),
            _c(VBreadcrumbs, {
              staticClass: "pa-0 py-2",
              attrs: { items: _vm.breadcrumbs },
            }),
            _c(
              VCard,
              { staticClass: "mt-2 pb-3 pr-3 pt-6" },
              [
                _c(
                  VForm,
                  { ref: "formsugerences" },
                  [
                    _c(
                      VRow,
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "10" } },
                          [
                            _c(
                              VAlert,
                              {
                                staticStyle: {
                                  "background-color": "#D5F3FF !important",
                                },
                                attrs: {
                                  text: "",
                                  color: "#0048cf",
                                  icon: "$info",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("help_center.sugerence_alert"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Módulo:")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "7" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                outlined: "",
                                rules: [
                                  function (v) {
                                    return !!v || "Module is required"
                                  },
                                ],
                              },
                              model: {
                                value: _vm.sugerence.seccion,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sugerence, "seccion", $$v)
                                },
                                expression: "sugerence.seccion",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Descripción:")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "7" } },
                          [
                            _c(VTextarea, {
                              attrs: {
                                outlined: "",
                                rows: "4",
                                rules: [
                                  function (v) {
                                    return !!v || "Details is required"
                                  },
                                ],
                              },
                              model: {
                                value: _vm.sugerence.detalles,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sugerence, "detalles", $$v)
                                },
                                expression: "sugerence.detalles",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { attrs: { justify: "center" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Comentarios adicionales(opcional)")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "7" } },
                          [
                            _c(VTextarea, {
                              attrs: { outlined: "", rows: "3" },
                              model: {
                                value: _vm.sugerence.comentario,
                                callback: function ($$v) {
                                  _vm.$set(_vm.sugerence, "comentario", $$v)
                                },
                                expression: "sugerence.comentario",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VFlex,
                      {
                        staticClass: "text-center mt-3",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          VBtn,
                          {
                            staticClass: "mr-1",
                            attrs: { outlined: "", color: "primary" },
                            on: { click: _vm.getBack },
                          },
                          [_vm._v(_vm._s(_vm.$t("btns.back")))]
                        ),
                        _c(
                          VBtn,
                          {
                            attrs: { color: "primary" },
                            on: { click: _vm.onSubmit },
                          },
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("icon-send")]
                            ),
                            _vm._v("Enviar"),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              VForm,
              { ref: "formsugerences" },
              [
                _c(
                  VRow,
                  { attrs: { justify: "center" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "10" } },
                      [
                        _c(
                          VAlert,
                          {
                            staticStyle: {
                              "background-color": "#D5F3FF !important",
                            },
                            attrs: {
                              text: "",
                              color: "#0048cf",
                              icon: "$info",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("help_center.sugerence_alert"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { attrs: { justify: "center" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "3" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v("Módulo:"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "7" } },
                      [
                        _c(VTextField, {
                          attrs: {
                            outlined: "",
                            rules: [
                              function (v) {
                                return !!v || "Module is required"
                              },
                            ],
                          },
                          model: {
                            value: _vm.sugerence.seccion,
                            callback: function ($$v) {
                              _vm.$set(_vm.sugerence, "seccion", $$v)
                            },
                            expression: "sugerence.seccion",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { attrs: { justify: "center" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "3" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v("Descripción:"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "7" } },
                      [
                        _c(VTextarea, {
                          attrs: {
                            outlined: "",
                            rows: "4",
                            rules: [
                              function (v) {
                                return !!v || "Details is required"
                              },
                            ],
                          },
                          model: {
                            value: _vm.sugerence.detalles,
                            callback: function ($$v) {
                              _vm.$set(_vm.sugerence, "detalles", $$v)
                            },
                            expression: "sugerence.detalles",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  VRow,
                  { attrs: { justify: "center" } },
                  [
                    _c(
                      VCol,
                      { attrs: { cols: "3" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v("Comentarios adicionales(opcional)"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "7" } },
                      [
                        _c(VTextarea, {
                          attrs: { outlined: "", rows: "3" },
                          model: {
                            value: _vm.sugerence.comentario,
                            callback: function ($$v) {
                              _vm.$set(_vm.sugerence, "comentario", $$v)
                            },
                            expression: "sugerence.comentario",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }